import { enhancedApi } from '@store/generated/customer-support';

// Receipts are user-scoped; keep no idle query cache after the widget unsubscribes.
export const jotSupportApi = enhancedApi.enhanceEndpoints({
  endpoints: {
    getV2ProviderSupportRequestsByRequestId: { keepUnusedDataFor: 0 },
  },
});
export const {
  usePostV2ProviderSupportRequestsMutation: useSubmitSupportRequest,
  useLazyGetV2ProviderSupportRequestsByRequestIdQuery: useCheckSupportRequest,
} = jotSupportApi;
